import { render, staticRenderFns } from "./OrderAllowanceCharges.vue?vue&type=template&id=3cbecad9&scoped=true&"
import script from "./OrderAllowanceCharges.vue?vue&type=script&lang=ts&"
export * from "./OrderAllowanceCharges.vue?vue&type=script&lang=ts&"
import style0 from "./OrderAllowanceCharges.vue?vue&type=style&index=0&id=3cbecad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbecad9",
  null
  
)

export default component.exports